import React from 'react'
import _ from 'lodash'

type Props = {
  onRender?: () => void
  delay?: number
}

type State = {
  ready: boolean
}

export class DelayRender extends React.Component<Props, State> {
  state: State = {
    ready: false
  }

  timeout = 0

  componentDidMount() {
    const { delay, onRender } = this.props
    if (delay && delay > 0) {
      this.setState({ ready: false })
      this.timeout = window.setTimeout(() => {
        this.setState({ ready: true })
        if (_.isFunction(onRender)) onRender()
      }, delay)
    } else {
      this.setState({ ready: true })
    }
  }

  componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  render() {
    const { children } = this.props
    const { ready } = this.state

    if (ready) return children
    return null
  }
}
